/* ============================================================================
   RENKEISEN · rk-vitrina.js
   Galeria modelo Seed (fichas con rkn.relato, clase .rk-seed).

   En el modelo el color del bloque de fotos no lo pone el tema: lo pone la
   foto. Aca se lee el borde de cada foto en un lienzo chico y ese color pasa
   a ser el fondo de su tarjeta, asi la foto se extiende hasta las esquinas
   redondeadas sin marco ni caja alrededor.

   - Borde parejo (fondo liso, lo normal en fotos de proveedor): la foto va
     contenida con aire y la tarjeta toma ese color.
   - Borde disparejo (una escena, una foto de ambiente): la foto cubre la
     tarjeta entera.

   Las fotos salen de /cdn/shop del mismo dominio de la tienda, asi que el
   lienzo no queda bloqueado. Si igual falla, la tarjeta se queda con su
   fondo claro por defecto: nada se rompe.
============================================================================ */
(function () {
  var raiz = document.querySelector('.rk-seed');
  if (!raiz) return;

  function leerBorde(img) {
    var n = 24, lienzo = document.createElement('canvas');
    lienzo.width = n; lienzo.height = n;
    var ctx = lienzo.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(img, 0, 0, n, n);
    var d = ctx.getImageData(0, 0, n, n).data, px = [];
    for (var i = 0; i < n; i++) {
      [[i, 0], [i, n - 1], [0, i], [n - 1, i]].forEach(function (p) {
        var k = (p[1] * n + p[0]) * 4;
        px.push([d[k], d[k + 1], d[k + 2]]);
      });
    }
    var s = [0, 0, 0];
    px.forEach(function (c) { s[0] += c[0]; s[1] += c[1]; s[2] += c[2]; });
    var m = s.map(function (v) { return v / px.length; });
    var dev = 0;
    px.forEach(function (c) { dev += Math.abs(c[0] - m[0]) + Math.abs(c[1] - m[1]) + Math.abs(c[2] - m[2]); });
    return { rgb: m.map(Math.round), dispar: dev / px.length > 36 };
  }

  function vestir(img) {
    var esc = img.closest('.rk-esc');
    if (!esc || esc.hasAttribute('data-rk-vitrina')) return;
    try {
      var b = leerBorde(img);
      esc.style.setProperty('--rk-foto-fondo', 'rgb(' + b.rgb.join(',') + ')');
      esc.setAttribute('data-rk-vitrina', b.dispar ? 'ambiente' : 'contener');
      if (b.dispar) esc.style.setProperty('--rk-foto-url', 'url("' + (img.currentSrc || img.src) + '")');
      if (!b.dispar && img.naturalWidth && img.naturalWidth < 700) esc.setAttribute('data-rk-chica', '');
      var luz = (b.rgb[0] * 299 + b.rgb[1] * 587 + b.rgb[2] * 114) / 1000;
      esc.setAttribute('data-rk-tono', luz < 140 ? 'oscuro' : 'claro');
    } catch (e) {
      esc.setAttribute('data-rk-vitrina', 'contener');
    }
  }

  /* En el mosaico de escritorio se ven todas las fotos, pero el visor abre la
     "activa". Antes de abrirlo, el clic en una foto la activa pulsando su
     miniatura (oculta), que es la via que ya usa la galeria. Va en captura
     para correr antes del listener que abre el visor. */
  var thumbs = raiz.querySelectorAll('[data-rk-gal-thumb]');
  raiz.querySelectorAll('[data-rk-gal-slide]').forEach(function (s, i) {
    var im = s.querySelector('img');
    if (im && thumbs[i]) im.addEventListener('click', function () { thumbs[i].click(); }, true);
  });

  raiz.querySelectorAll('.rk-gal .rk-esc img, .rk-gal__thumbs img').forEach(function (img) {
    if (img.closest('.rk-gal__thumbs')) {
      var t = img.closest('button, a, .rk-gal__thumb');
      if (!t) return;
      var hecho = function () {
        try {
          var b = leerBorde(img);
          t.style.setProperty('--rk-foto-fondo', 'rgb(' + b.rgb.join(',') + ')');
        } catch (e) {}
      };
      if (img.complete && img.naturalWidth) hecho(); else img.addEventListener('load', hecho, { once: true });
      return;
    }
    if (img.complete && img.naturalWidth) vestir(img);
    else img.addEventListener('load', function () { vestir(img); }, { once: true });
  });

  /* ============================================================
     CARGA DIFERIDA DE LOS VIDEOS DE LA HISTORIA          13-09-2026
     Cada <video data-src> de snippets/rk-gif.liquid llega sin src:
     ni un byte se pide hasta que el bloque esta a 600px de entrar
     en pantalla. En un 4G eso es la diferencia entre competir por
     ancho de banda con el LCP o no pedir nada hasta que hace falta.

     Con movimiento reducido el video igual se carga (sigue siendo
     contenido, no solo adorno) pero no se reproduce: queda quieto
     en su primer cuadro, que es lo unico que respeta la preferencia
     sin negarle el dato a quien la pidio.
  ============================================================ */
  var reduceMv = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var videosDiferidos = raiz.querySelectorAll('video[data-src]');
  if (videosDiferidos.length) {
    if (!('IntersectionObserver' in window)) {
      videosDiferidos.forEach(function (v) {
        v.muted = true;
        v.defaultMuted = true;
        v.src = v.getAttribute('data-src');
        v.removeAttribute('data-src');
        if (!reduceMv) { v.autoplay = true; v.play().catch(function () {}); }
      });
    } else {
      var ioVid = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (en) {
          if (!en.isIntersecting) return;
          var v = en.target;
          /* muted como PROPIEDAD y no solo como atributo: Safari/iOS decide
             si un autoplay esta permitido mirando el estado real del
             elemento en ese instante, y a veces no alcanza con el atributo
             muted del HTML inicial. defaultMuted cubre un load() posterior. */
          v.muted = true;
          v.defaultMuted = true;
          v.src = v.getAttribute('data-src');
          v.removeAttribute('data-src');
          v.load();
          if (!reduceMv) { v.play().catch(function () {}); }
          ioVid.unobserve(v);
        });
      }, { rootMargin: '600px 0px' });
      videosDiferidos.forEach(function (v) { ioVid.observe(v); });
    }
  }

  /* ============================================================
     CARRUSEL DE BENEFICIOS (B1): PUNTOS + PISTA DE DESLIZAR   14-09-2026
     "sale cortado y no se entiende que se corre hacia el lado". El
     desvanecido del borde ya existia pero era pasivo: aca se agregan
     senales activas — puntos que se sincronizan con la tarjeta visible y
     sirven de atajo tocable, y una pista de texto que desaparece en cuanto
     la persona desliza una vez, para no insistir despues de que entendio.

     POR QUE offsetLeft Y NO IntersectionObserver: la tarjeta "activa" se
     calcula comparando el centro del riel visible contra el centro de cada
     tarjeta (mismo calculo que ya hace scroll-snap por dentro), en un
     'scroll' con throttle a un frame via requestAnimationFrame. Un
     IntersectionObserver con threshold fijo es mas elegante en teoria, pero
     depende de que el motor entregue frames de interseccion a tiempo — en
     pestañas en segundo plano o recien restauradas eso puede demorar mas de
     lo que dura la propia animacion de scroll. El calculo geometrico
     responde siempre, en cuanto el navegador dispara 'scroll'.

     document, NO raiz (14-09-2026): la ficha fragmentada en tres secciones
     (ver snippets/rk-producto-contexto.liquid) deja DOS ".rk-seed" en el
     DOM — uno por seccion, S1/galeria y S2/historia — y raiz aca arriba es
     solo el PRIMERO que encuentra document.querySelector (el de S1). El
     carrusel de beneficios vive en S2, asi que buscarlo "dentro de raiz"
     nunca encontraba nada. El script entero solo se carga en fichas con
     rkn.relato (ver el include condicional en rk-producto-historia.liquid),
     asi que buscar en todo el documento es seguro: no hay falso positivo
     posible en una pagina sin este carrusel.
  ============================================================ */
  document.querySelectorAll('[data-rk-carrusel]').forEach(function (riel) {
    var carrusel = riel.closest('.rk-h-bene__carrusel');
    if (!carrusel) return;
    var items = Array.prototype.slice.call(riel.querySelectorAll('[data-rk-carrusel-item]'));
    var dots = Array.prototype.slice.call(carrusel.querySelectorAll('[data-rk-carrusel-dot]'));
    var pista = carrusel.querySelector('[data-rk-carrusel-pista]');
    if (!items.length) return;

    var activo = -1;
    function activar(i) {
      if (i === activo) return;
      activo = i;
      dots.forEach(function (d, idx) {
        d.setAttribute('aria-selected', idx === i ? 'true' : 'false');
      });
    }
    function masCercano() {
      var centro = riel.scrollLeft + riel.clientWidth / 2;
      var mejorI = 0, mejorDist = Infinity;
      items.forEach(function (it, i) {
        var medio = it.offsetLeft - riel.offsetLeft + it.offsetWidth / 2;
        var dist = Math.abs(medio - centro);
        if (dist < mejorDist) { mejorDist = dist; mejorI = i; }
      });
      return mejorI;
    }

    if (dots.length) activar(masCercano());

    /* Sin requestAnimationFrame: son a lo sumo 4 tarjetas, el calculo es
       trivial, y encolar el trabajo un frame despues solo suma una fuente
       de demora que no hace falta (y que en pestañas recien restauradas o
       en segundo plano puede tardar mucho mas que el propio scroll). Se
       actua directo en cada evento 'scroll'. */
    riel.addEventListener('scroll', function () {
      if (pista) pista.classList.add('rk-h-bene__pista--oculta');
      if (dots.length) activar(masCercano());
    }, { passive: true });

    dots.forEach(function (d, idx) {
      d.addEventListener('click', function () {
        var it = items[idx];
        if (it) it.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      });
    });
  });
})();
